<template>
  <v-footer light
            padless>
    <v-card flat
            tile
            class=" lighten-1 
                    font-weight-bold
                    grey--text
                    text-center">
      <v-card-text class="headline 
                          grey-text 
                          text-center">
          About us?
      </v-card-text>
      <v-card-text class="grey--text my-1">
        Phasellus feugiat arcu sapiien, et iaculis ipsum elementum sit amet. Mauris cursus commodo interdum. Praesent ut risus eget metus luctus accumsan id ultrices nunc. Sed at orci sed massa consectetur dignissim a sit amet dui. Duis commodo vitae velit et faucibus. Morbi vehicula lacinia malesuada. Nulla placerat augue vel ipsum ultrices, cursus iaculis dui sollicitudin. Vestibulum eu ipsum vel diam elementum tempor vel ut orci. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
      </v-card-text>
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 grey--text"
          icon>
          <v-icon large>{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="grey--text">
        {{ new Date().getFullYear() }} &copy; <strong>telmomz</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
  export default {
    data: () => ({
      icons: [
        'fab fa-facebook',
        'fab fa-facebook-messenger',
        'fab fa-instagram',
      ],
    }),
  }
</script>